import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
body {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}
header{
  background-color: ${({ theme }) => theme.body};
}
button {
  background-color:${({ theme }) => theme.button};
  color:${({ theme }) => theme.buttonText};
}
a:hover{
  color: ${({ theme }) => theme.text};
}
a{
  color: ${({ theme }) => theme.text};
}
.text-color-button{
  color:${({ theme }) => theme.button} !important;
}
input::placeholder,textarea::placeholder {
  color: ${({ theme }) => theme.text} !important;
}
.theme-text-color {
  color: ${({ theme }) => theme.text} !important;
}
.theme-bg-color{
  background-color: ${({ theme }) => theme.body} !important;
}
.theme-bg-color-secondary{
  background-color: ${({ theme }) => theme.secondarybody} !important;
}
.theme-border-primary-color{
  border-color: ${({ theme }) => theme.body} !important;
}
.theme-border-secondary-color{
  border-bottom:2px solid  ${({ theme }) => theme.secondarybody} !important;
}

.theme-border-button-color{
border-color : ${({ theme }) => theme.button} !important;
}
.theme-button-bg-color {
  background-color: ${({ theme }) => theme.button};
}
.theme-border-secondary{
  border: 3px solid ${({ theme }) => theme.secondarybody} !important;
}
.theme-border-bottom-text-bold{
  border-bottom: 3px solid ${({ theme }) => theme.text} !important;
}
.theme-border-bottom-text{
  border-bottom: 1px solid ${({ theme }) => theme.text} !important;
}
.theme-border-bottom-secondary{
  border-bottom: 2px solid ${({ theme }) => theme.secondarybody} !important;
}
.theme-border-color{
  border-color: ${({ theme }) => theme.secondarybody} !important;
}
  .theme-border-color-primary{
   border-color: ${({ theme }) => theme.body} !important;
  }
  .theme-border-button-color{
    border: 2px solid ${({ theme }) => theme.button} !important;
    border-bottom-color:${({ theme }) => theme.body} !important;
  }
  .theme-body-text-color{
  color: ${({ theme }) => theme.body} !important;
  }
  .theme-secondary-body-text-color{
  color: ${({ theme }) => theme.secondarybody} !important;
  }


.bootstrapTable table>thead>tr>th{
  border-bottom: 2px solid ${({ theme }) => theme.secondarybody} !important;
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}
.bootstrapTable table>tbody>tr{
  border-bottom: 2px solid ${({ theme }) => theme.secondarybody} !important;
}
.bootstrapTable table>tbody>tr>td{
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
}

.editdropdown-menu a:hover{
  background-color: ${({ theme }) => theme.secondarybody} !important;
}
.commonActionPadding:hover {
  background-color: ${({ theme }) => theme.secondarybody} !important;
}
#pageDropDown{
  background-color: ${({ theme }) => theme.body};
  border: 1px solid ${({ theme }) => theme.secondarybody} !important;
  color: ${({ theme }) => theme.text} !important;
}
.custom-input-border{
border:1px solid ${({ theme }) => theme.secondarybody} !important;
  }
.custom-input:focus-visible{
outline:1px solid ${({ theme }) => theme.secondarybody} !important;
}
.custom-input.custom-input-error:focus-visible {
 outline: none !important;
}
 .custom-input.custom-input-error {
 border:2px solid #ff2c2c !important;
}
  .custom-jodit.custom-input-error {
 border:2px solid #ff2c2c !important;
}

.custom-select-multi.custom-input-error {
 border:2px solid #ff2c2c !important;
}
 .imagedrop.custom-input-error{
  border-color: #ff2c2c !important;
 outline-color: #ff2c2c !important;
 }
 .custom-search-tag>button ,.custom-search-tag>button:hover,.custom-search-tag>button:focus {
 color:#ff2c2c !important;
 }

 .errored-bg{
 background-color:#ff2c2c
 }
.custom-select-multi .css-wsp0cs-MultiValueGeneric{
 background-color: ${({ theme }) => theme.secondarybody} !important;
 }
 .custom-select-multi .css-12a83d4-MultiValueRemove{
  border: 1px solid ${({ theme }) => theme.secondarybody} !important;
 }
.rti--tag >span{
background-color: ${({ theme }) => theme.secondarybody} !important;
}
.rti--tag >button{
  border: 1px solid ${({ theme }) => theme.secondarybody} !important;
}
input[name="search_tags"]{
 
}
.tool-tip-text{
 background-color: ${({ theme }) => theme.secondarybody} !important;
}






.react-bs-table-sizePerPage-dropdown .dropdown-menu {
  background-color: ${({ theme }) => theme.body} !important;
   color: ${({ theme }) => theme.text} !important;
}
.bootstrapTable .page-link {
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text} !important;
  border-color:${({ theme }) => theme.secondarybody} !important;
}

.bootstrapTable .page-item.active > .page-link{
  background-color: ${({ theme }) => theme.secondarybody} !important;
}

.adminHeadContainer .dropdown-item:hover, .adminHeadContainer .dropdown-item:focus{
  background-color: ${({ theme }) => theme.secondarybody};
}

.jodit-container *{
  font-family:'Poppins'
}
.jodit-toolbar__box, .jodit-workplace,.jodit-status-bar{
  background-color: ${({ theme }) => theme.secondarybody} !important;
  color: ${({ theme }) => theme.text} !important;
}
.jodit-toolbar__box svg{
  fill: ${({ theme }) => theme.text} !important;
}
.css-1nmdiq5-menu > *{
  background-color: ${({ theme }) => theme.secondarybody} !important;
  color: ${({ theme }) => theme.text} !important;
}
.css-1p3m7a8-multiValue, .css-wsp0cs-MultiValueGeneric{
  background-color: ${({ theme }) => theme.body} !important;
  color: ${({ theme }) => theme.text};
}
.css-1xc3v61-indicatorContainer >svg{
  fill:${({ theme }) => theme.text};
}
.rti--tag{
  background-color: ${({ theme }) => theme.body};
}
.orderTitle.active::before{
background-color:${({ theme }) => theme.button} 
}
.secondary:hover{
background-color:${({ theme }) => theme.body} !important;
}
.primary:hover{
background-color:${({ theme }) => theme.secondarybody} !important;
}
.theme-button-text-color{
color:${({ theme }) => theme.buttonText} !important;
}
.subscriptionPlan:hover{
    background-color:${({ theme }) => theme.secondarybody} !important;
}
.button-bg-color,.button-bg-color:hover{
background-color:${({ theme }) => theme.button} 
}
input:checked+.admin-slider {
background-color:${({ theme }) => theme.button} 
}
input:focus+.admin-slider {
box-shadow: 0 0 1px ${({ theme }) => theme.button};
}

.admin-slider:before {
background-color:${({ theme }) => theme.buttonText} 
}
.append-text{
  background-color:${({ theme }) => theme.secondarybody} !important;
}
.vjs-big-play-button{
    background-color:${({ theme }) => theme.button} !important;
}
`;